import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "form-group" }
const _hoisted_2 = { class: "form-group" }
const _hoisted_3 = { class: "d-flex" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_auto_textarea = _resolveComponent("auto-textarea")!
  const _component_menu_entry = _resolveComponent("menu-entry")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _cache[2] || (_cache[2] = _createElementVNode("label", null, "Numero menu", -1)),
      _withDirectives(_createElementVNode("input", {
        type: "text",
        class: "form-control",
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.localValue.dayNumber) = $event))
      }, null, 512), [
        [_vModelText, _ctx.localValue.dayNumber]
      ])
    ]),
    _createElementVNode("div", _hoisted_2, [
      _cache[3] || (_cache[3] = _createElementVNode("label", null, "Note (opzionale)", -1)),
      _createVNode(_component_auto_textarea, {
        class: "form-control",
        modelValue: _ctx.localValue.note,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.localValue.note) = $event))
      }, null, 8, ["modelValue"])
    ]),
    _createElementVNode("div", _hoisted_3, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.localValue.entries, (item, i) => {
        return (_openBlock(), _createBlock(_component_menu_entry, {
          key: i,
          modelValue: item
        }, null, 8, ["modelValue"]))
      }), 128))
    ])
  ]))
}